import { combineReducers } from 'redux';

import {
  ACTION_LOAD_LAST_PAYOUT__REQUEST,
  ACTION_LOAD_LAST_PAYOUT__SUCCESS,
  ACTION_LOAD_LAST_PAYOUT__FAIL,
} from '../actionTypes/lastPayout';


const payout = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_LAST_PAYOUT__SUCCESS:
      return action.payload.payout;

    case ACTION_LOAD_LAST_PAYOUT__FAIL:
      return null;

    default:
      return state;
  }
};

const errors = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_LAST_PAYOUT__REQUEST:
    case ACTION_LOAD_LAST_PAYOUT__SUCCESS:
      return {
        ...state,
        getLastPayout: null,
      };

    case ACTION_LOAD_LAST_PAYOUT__FAIL:
      return { ...state, loadLastPayout: action.payload.error };

    default:
      return state;
  }
};

export default combineReducers({
  payout,
  errors,
});
